import { createSelector } from '@ngrx/store';
import { selectDigitaixState } from '../core.selectors';

export const selectLoadingState = createSelector(
  selectDigitaixState,
  (state) => state.loading,
);

export const isLoading = createSelector(
  selectLoadingState,
  (state) => state.isLoading !== 0,
);
